import React, { useEffect } from "react";
import { App, ConfigProvider, Empty } from "antd";
import { createRoot } from "react-dom/client";
// import { EditableContextProvider } from "../../common/EditableContextProvider";
import { Select, Pagination } from "antd";
import { useClientesTech } from "./useClientesTech";

export const Main = () => {
    const clientesTech = useClientesTech();

    const handleLogoError = (e) => {
        e.target.onerror = null;
        e.target.src = 'https://myquickone.com/assets_one/img/not_found.jpg';
    }

    useEffect(() => {
        clientesTech.fillItems();
    }, [clientesTech.items.page, clientesTech.items.rubro]);

    return (
        <div>
            <div className="text-center p-2 my-3">
                <h4>
                    ÚNETE A LOS MILES DE CLIENTES QUE <br />
                    QUE CONFÍAN EN NOSOTROS!
                </h4>
            </div>

            <div className="text-center my-2 p-2 row">
                <div className="col-md"></div>
                <div className="col-md-auto">
                    <Select
                        style={{ display: "block", width: "200px" }}
                        value={clientesTech.items.rubro}
                        options={[
                            { label: "Todos", value: "" },
                            { label: "Gastronomía", value: 3 },
                            { label: "Productos", value: 1 },
                            { label: "Servicios", value: 2 },
                        ]}
                        onChange={(value) => clientesTech.setItems(prev => ({ ...prev, rubro: value, page: 1 }))}
                    ></Select>
                </div>
                <div className="col-md"></div>
            </div>

            <div className="d-flex flex-wrap justify-content-between">
                {clientesTech.items.total === 0 ? (
                    <Empty style={{ width: "100%", margin: "3em" }} />
                ) : (
                    <></>
                )}

                <div className="row">
                    {clientesTech.items.data.map((it) => (
                        <div
                            key={it.id}
                            className="p-2 my-4 px-3 flex-shrink-2 col-md-4"
                        >
                            <div className="text-center">
                                <a
                                    href={`https://cat.quick.com.bo/${it.slug}`}
                                    target="_blank"
                                >
                                    <img
                                        src={it.logo}
                                        className="m-1 rounded-3"
                                        alt=""
                                        loading="lazy"
                                        style={{
                                            height: "250px",
                                            objectFit: "contain",
                                            maxWidth: "100%",
                                        }}
                                        onError={handleLogoError}
                                    />
                                </a>
                                <div>
                                    <b>{it.name}</b>
                                </div>
                                <div style={{ color: "#08d508" }}>
                                    Pedidos: {it.total_sales}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="py-4">
                {/* <Pagination
                    pageSize={45}
                    // defaultCurrent={1}
                    total={clientesTech.items.total}
                    current={clientesTech.items.page}
                    onChange={(page, pageSize) => {
                        clientesTech.setItems(prev => ({
                            ...prev,
                            page: page,
                        }))
                        console.log(`page: ${page}`);
                        console.log(`pageSize: ${pageSize}`);
                    }}

                    pageSizeOptions={[45]}
                /> */}
            </div>
        </div>
    );
};

const main = document.getElementById("clientes-tech-main");
const data = main.dataset;

if (main) {
    if (!main.root) {
        main.root = createRoot(main);
    }
    main.root.render(
        <React.StrictMode>
            <ConfigProvider
                theme={{
                    token: {
                        fontFamily: "Poppins",
                        colorPrimary: "rgb(11, 183, 131)",
                    },
                }}
            >
                <App>
                    <Main managed={data.managed} />
                </App>
            </ConfigProvider>
        </React.StrictMode>,
    );
}
